// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dot[data-v-677709ce] {\n  position: relative;\n  top: 9px;\n  font-size: 3rem;\n  line-height: 0.1rem;\n}\ndt[data-v-677709ce] {\n  border: none !important;\n  padding: 0.2rem;\n  font-weight: normal;\n}\ndl[data-v-677709ce] {\n  margin-bottom: 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
